import { gql } from '__generated__';

export const DiscountFieldsFragment = gql(`
  fragment DiscountFields on Discount {
    id
    title
    type
    start_date
    end_date
    uses
    active
    tickets {
      id
    }
    products {
      id
    }
    levels {
      id
      quantity
      value
    }
    locale
    translations {
      ...TranslationFields
    }
  }
`);

export default gql(`
  query GetDiscount($event_id: ID!, $discount_id: ID!) {
    discount(id: $discount_id) {
      ...DiscountFields
    }
    event(id: $event_id) {
      id
      locale
      tickets {
        id
        title
        discounts {
          id
        }
      }
      products {
        id
        title
        type
        discounts {
          id
        }
      }
    }
  }
`);
